import axios from "axios"
import { Apis } from "constants/apis"

const googleLogin = async (payload: any) => {
    const { data } = await axios.post(Apis.GOOGLE_LOGIN, payload)
    return data
}

export default googleLogin